import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { PregnancyService } from '../pregnancy.service';
import { LoginService } from '../login.service';

@Component({
  selector: 'app-closepregnancy',
  templateUrl: './closepregnancy.component.html',
  styleUrls: ['./closepregnancy.component.scss'],
  standalone: false,
})
export class ClosepregnancyComponent implements OnInit {
  @Output() closed = new EventEmitter<null>();
  @Output() examClosed = new EventEmitter<null>();
  @Input('pregtoload') pregIDtoLoad: number;
  @Input('exams') exams: any;

  isclosed = false;
  editing = false;

  constructor(
    public ps: PregnancyService,
    public ls: LoginService
  ) {}

  ngOnInit() {
    if (this.exams && this.exams.length > 0)
      this.ps.setExamID(this.exams[0].AutoIndex, this.exams[0].CreationTime);
    if (this.pregIDtoLoad) this.ps.loadPreg(this.pregIDtoLoad, () => this.lockWhenClosed());
  }

  // Exactly the controls this popup renders — other views bind to the same shared pregForm.
  private editableFields(): string[] {
    const fields = ['TerminationDate', 'TerminationType', 'NumFetuses', 'TerminationRemarks'];
    for (let fetus = 1; fetus <= 4; fetus++) {
      fields.push('Fetus' + fetus + 'Sex', 'Fetus' + fetus + 'Wt', 'Fetus' + fetus + 'Anomolies');
    }
    return fields;
  }

  private setFieldsEnabled(enabled: boolean) {
    for (const field of this.editableFields()) {
      const control = this.ps.pregForm.get(field);
      if (!control) {
        continue;
      }
      if (enabled) {
        control.enable({ emitEvent: false });
      } else {
        control.disable({ emitEvent: false });
      }
    }
  }

  // A closed pregnancy has no autosave wiring, so it opens read-only until Edit is pressed.
  private lockWhenClosed() {
    if (this.ps.pregForm.get('ClosedDate').value) {
      this.setFieldsEnabled(false);
    }
  }

  get isPregnancyClosed(): boolean {
    return this.isclosed || !!this.ps.pregForm.get('ClosedDate').value;
  }

  get canEdit(): boolean {
    return this.ls.userType === 'doctor' && this.isPregnancyClosed && !this.editing;
  }

  startEdit() {
    this.setFieldsEnabled(true);
    this.editing = true;
  }

  saveEdit() {
    this.ps.saveDirtyFields();
    this.setFieldsEnabled(false);
    this.editing = false;
  }

  closeMax(): Date {
    let d = new Date();
    let dt = Date.parse(this.ps.getLMP());
    d.setTime(dt + 48 * 7 * 24 * 60 * 60 * 1000);
    return d;
  }

  closePreg() {
    this.ps.close();
    this.examClosed.emit();
    this.isclosed = true;
  }
}
